function getDeviceType() {
    const userAgent = navigator.userAgent;

    if (/Macintosh/.test(userAgent)) {
        return 'mac';
    }
    if (/Windows NT|Windows Phone|android|iPad|iPhone|iPod/i.test(userAgent)) {
        return 'windows';
    }
    if (/Linux/.test(userAgent)) {
        return 'linux';
    }
    return 'unknown';
}
document.addEventListener('DOMContentLoaded', function () {
    const deviceType = getDeviceType();
    const body = document.body;
    body.classList.add('device-' + deviceType);
});

$('.slick-slider ul').slick({
    arrows: true,
    centerMode: true,
    centerPadding: '40px',
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 3
            }
        },
        {
            breakpoint: 480,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1
            }
        }
    ]
});

$(window).on('load', function () {
    // Get the inner height of the heading element
    let headingHeight = $('.product__title').innerHeight();

    // Calculate the new top value
    let newTopValue = headingHeight + 14;

    // Apply the new top value to each matched element
    $('.product__info-container .yotpo-widget-instance').each(function () {
        $(this).css('top', newTopValue + 'px');
    });

    // Show the element after adjustments
    $('.product__info-container .yotpo-widget-instance').show();
});

document.addEventListener('DOMContentLoaded', function () {
    // Create an Intersection Observer instance
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            // Check if the element is in the viewport
            if (entry.isIntersecting) {
                // Add the visible class to trigger animation
                entry.target.classList.add('visible');
            } else {
                // Remove the visible class if you want the animation to repeat when scrolling out and back in
                entry.target.classList.remove('visible');
            }
        });
    }, {
        threshold: 0.1  // Adjust this to trigger when the element is partially visible
    });

    // Target elements to observe
    document.querySelectorAll('.program-perks .multicolumn-card__image-wrapper').forEach((element) => {
        observer.observe(element);
    });
});

document.addEventListener('DOMContentLoaded', () => {
    // Select the link
    const scrollLink = document.querySelector('.pi-utility-bar__link');
    // Absent on most templates. Unguarded this threw a TypeError and killed the rest of
    // this handler; dh-common.js is render-blocking, so it cost load time as well.
    if (!scrollLink) return;
  
    // Add click event listener
    scrollLink.addEventListener('click', (event) => {
      event.preventDefault(); // Prevent default link behavior
  
      // Get the target element's position
      const targetId = scrollLink.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
  
      if (targetElement) {
        // Smooth scroll to the target element
        targetElement.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
  });
  


  document.addEventListener('DOMContentLoaded', function() {
    // Check if the link exists
    var link = document.querySelector('.fpage-page\.affiliate-program .become-a-gel .rich-text__buttons a');
    
    if (link) {
        // Extract the target ID from the href attribute
        var targetId = link.getAttribute('href').substring(1); // Remove the '#' from href
        var targetElement = document.getElementById(targetId);
        
        if (targetElement) {
            // Add the click event listener only if the target element exists
            link.addEventListener('click', function(event) {
                event.preventDefault(); // Prevent the default anchor behavior

                // Calculate the target position with the offset
                var offset = 80;
                var targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;

                // Smooth scroll to the calculated position
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            });
        } else {
            console.error('Target element not found: ' + targetId);
        }
    } else {
        console.error('Link not found with the given selector.');
    }
});



$('.header__icon--search').on("click", function(){
    $('body').toggleClass("search-open")
})

var currentElem;	

function stopScroll() 
{
    if(currentElem)
    {
        var top = $("input:focus").offset().top;
        $('html, body').stop().animate({
            scrollTop: top
        }, 500, function(){});
    }
}

function disableScrolling(elem) 
{
    currentElem = elem;
    document.addEventListener("touchend", stopScroll);
    setTimeout(function()
    {
        stopScroll();
    },10);
}

function enableScrolling() 
{
    currentElem = undefined;
    document.removeEventListener("touchend", stopScroll);
}